import React from 'react';

import cx from 'classnames';

import styles from './Leaderboard.module.scss';

export type TLeaderboardTableRow = {
  key: string;
  isUserRow?: boolean;
  cells: [React.ReactNode, React.ReactNode, React.ReactNode];
};

type TLeaderboardTableProps = {
  headers: [React.ReactNode, React.ReactNode, React.ReactNode];
  rows: TLeaderboardTableRow[];
  emptyLabel: string;
};

export const LeaderboardTable: React.FC<TLeaderboardTableProps> = ({
  emptyLabel,
  headers,
  rows,
}) => (
  <div className={styles.leaderboardTable} role="table">
    <div className={styles.tableHead} role="rowgroup">
      <div className={styles.tableRow} role="row">
        {headers.map((header, index) => (
          <div
            className={cx(styles.cell, styles.headCell)}
            key={`head-${index}`}
            role="columnheader"
          >
            {header}
          </div>
        ))}
      </div>
    </div>
    <div className={styles.tableBody} role="rowgroup">
      {rows.map((row) => (
        <div
          className={cx(styles.tableRow, row.isUserRow && styles.userRow)}
          key={row.key}
          role="row"
        >
          <div className={styles.cell} role="cell">
            {row.cells[0]}
          </div>
          <div className={cx(styles.cell, styles.nameCell)} role="cell">
            {row.cells[1]}
          </div>
          <div className={styles.cell} role="cell">
            {row.cells[2]}
          </div>
        </div>
      ))}
      {rows.length === 0 ? (
        <div className={styles.tableRow} role="row">
          <div className={cx(styles.cell, styles.noData)} role="cell">
            {emptyLabel}
          </div>
        </div>
      ) : null}
    </div>
  </div>
);
